import { formatGetHeaders } from '@configurations/api-configuration';
import { PsfUserGateway } from '@scenario/gateways/psf-user.gateway';
import { PsfUser } from '@scenario/models/psf-user.model';
import { environment } from '../../../../../environments/environment';

export class ApiPsfUserGateway implements PsfUserGateway {
  private readonly userApi = `${environment.backend_url}/api/v1/user`;

  async retrieveAll(): Promise<PsfUser[]> {
    const response = await fetch(this.userApi, await formatGetHeaders());
    if (!response.ok) {
      throw new Error(`Failed to retrieve users: ${response.status}`);
    }
    return response.json();
  }
}
